<template>
  <div class="newsletter p-100">
    <div class="container">
      <div class="row">
        <div class="col-12 mb-4 text-center">
          <h1 class="h1-after-center text-uppercase fwb mb-4">
            Assine nossa Newsletter
          </h1>
          <div class="box-desc text-center">
            <p class="roboto-n">Receba em seu e-mail nossas novidades!</p>
          </div>
        </div>
        <div class="col-12">
          <form action>
            <div class="form-row justify-content-center">
              <div class="col-md-2 mb-lg-0 mb-md-0 mb-3">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Nome"
                  v-model="receive.name"
                  required
                />
              </div>
              <div class="col-md-3 mb-lg-0 mb-md-0 mb-3">
                <input
                  type="email"
                  class="form-control"
                  placeholder="E-mail"
                  v-model="receive.email"
                  required
                />
              </div>
              <button
                type="button"
                class="btn bg-orange c-white text-uppercase"
                @click="receiveNewsletter()"
              >
                Receber
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import makeToast from '../mixins/makeToast';

export default {
  mixins: [makeToast],
  data() {
    return {
      receive: {
        email: null,
        name: null,
      },
    };
  },
  methods: {
    receiveNewsletter() {
      if (!this.$validate.name(this.receive.name)) {
        this.makeToast(
          'Sucesso',
          'Por favor, digite um nome válido!',
          'warning'
        );
      } else if (!this.$validate.email(this.receive.email)) {
        this.makeToast(
          'Sucesso',
          'Por favor, digite um email válido!',
          'warning'
        );
      } else {
        this.$store.dispatch('startLoader');
        this.$store
          .dispatch('sendMailNewsletter', this.receive)
          .then(() => {
            setTimeout(() => {
              this.$store.dispatch('endLoader');
              this.makeToast(
                'Sucesso',
                'Obrigado por assinar nossa Newsletter!',
                'success'
              );
            }, 1000);
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
          });
      }
    },
  },
};
</script>

<style>
@import '../custom/css/home-page.css';
</style>
